// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__29leO","resendInfoText":"OnGoingPaymentBox_resendInfoText__1Vdd5"};